import React from "react";
import { ZodType, ZodTypeDef } from "zod";

import { FormState } from "components/organisms/Form/types";

// context
import { usePyForm } from "../../../context";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type FormSubscribeProps<TSchema extends ZodType<any, ZodTypeDef, any>, TSelected> = {
	id: string;
	selector: (state: FormState<TSchema>) => TSelected;
	children: (state: TSelected) => React.ReactNode;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const FormSubscribe = <TSchema extends ZodType<any, ZodTypeDef, any>, TSelected = any>(
	props: FormSubscribeProps<TSchema, TSelected>
) => {
	const form = usePyForm<TSchema>();
	return (
		<form.Subscribe selector={props.selector}>
			{(state) => {
				return props.children(state);
			}}
		</form.Subscribe>
	);
};

export default FormSubscribe;
